import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
// Import notifications
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
// Import Vue and vue-highlgihtjs
import VueHighlightJS from 'vue-highlightjs';
import VueAnalytics from 'vue-analytics';
import VueMeta from 'vue-meta';
import Vue from 'vue';
import App from './App';
import router from './router';


// Enable notifications
miniToastr.init({ allowHtml: true });

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb);
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast,
};

Vue.use(VueNotifications, options);

// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS);

// Setup Vue Bootstrap
Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true,
});

// Use moment
Vue.use(require('vue-moment'));

Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue').default);
Vue.component('fade-loader', require('vue-spinner/src/FadeLoader.vue').default);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
});

// Google Analytics
Vue.use(VueAnalytics, {
    id: 'UA-109233664-3',
    router,
});



// WEBPACK FOOTER //
// ./src/main.js